import { FilterOptions } from '../model/filter-options.model';
import { OrderBy } from '../model/order-by.model';
import { ViewTaskItem } from '../model/view-task-item.model';

import { filterByDateRange } from './filter-by-date-range.function';
import { filterByKeyword } from './filter-by-keyword.function';
import { filterByStatus } from './filter-by-status.function';
import { sortItems } from './sort-items.function';

export function filterItems(opts: {
    items: ViewTaskItem[];
    filterOpts: FilterOptions;
    orderBy: OrderBy;
}): ViewTaskItem[] {
    let nextFilt = filterByStatus(opts.filterOpts.status, opts.items);
    nextFilt = filterByDateRange(opts.filterOpts.dateRange, nextFilt);
    nextFilt = filterByKeyword(opts.filterOpts.keyword, nextFilt);
    return sortItems(opts.orderBy, nextFilt);
}
